import * as React from "react";
import { Role, WebPortalClient } from "webportalclient";
import DocumentTitle from "../../misc/components/DocumentTitle";
import '../../misc/Collapsible.scss';
import { Link, useParams } from "react-router-dom";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { AuditModal } from "../../auditmodal/components/AuditModal";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const AlignRoles = () => {
    const client = useWebPortalApiClient();
    const { id } = useParams<{ id: string }>();
    const [role, setRole] = React.useState<Role>();
    const [roles, setRoles] = React.useState<Role[]>([]);
    const [auditModal, setAuditModal] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [saved, setSaved] = React.useState(false);
    const [errored, setErrored] = React.useState(false);

    React.useEffect(() => {

        const getRoles = async () => {

            const role = await client.client.getRole(id);
            setRole(role);
            setRoles((await client.client.getRoles(undefined, `studyId eq ${role.studyId}`, 'id,name')).value);
        }

        getRoles();

    }, [client.client]);

    const handleChecked = (roleId: string) => {

        if (role.childRolesIds.some(r => r == roleId))
            setRole({ ...role, childRolesIds: role.childRolesIds.filter(r => r != roleId) });
        else
            setRole({ ...role, childRolesIds: [...role.childRolesIds, roleId] });
    }
    

    const handleSave = async () => {

        setSubmitting(true);

        try {

            await client.client.patchRole({ childRolesIds: role.childRolesIds }, id);
           
            setSaved(true);
            setErrored(false);

        } catch {
            setSaved(false);
            setErrored(true);
        }
        
        setSubmitting(false);
        setAuditModal(false);
    }

    if (!role)
        return <LoadingWithMessage message="Loading Roles..." />

    const roleList = roles.map(r => (
        <tr key={`Role${r.id}`}>
            <td>
                <label htmlFor={r.id}>{r.name}</label>
            </td>
            <td className="col-md-6">
                <input id={r.id} type="checkbox" checked={role.childRolesIds.some(p => p == r.id)} onChange={() => handleChecked(r.id)} disabled={submitting} />
            </td>
        </tr>
    ));

    return (
        <DocumentTitle title="Align Roles To Role | Vitalograph Web Portal">
            <Alert show={saved} category={AlertCategoryEnum.Success}>Saved successfully. Return to <Link to={`/rolemanagement`}>Role management list</Link>?</Alert>
            <Alert show={errored} category={AlertCategoryEnum.Danger}>Failed to save changes.</Alert>
            
            <div className="row">
                <div className="col-md-6"><h2 className="text-primary">Align Roles to Role - {role.name}</h2></div>
                <div className="col-md-6  text-right h2">
                    <button className="btn btn-primary" type="button" onClick={() => setAuditModal(true)}>Save</button>&nbsp;
                    <Link className="btn btn-primary btn-outline" to="/rolemanagement">Return to List</Link>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="panel">
                        <div className="panel-body">
                            <table className="table table-striped table-bordered table-hover">
                                <tbody>{roleList}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 text-right h2">
                    <button className="btn btn-primary" type="button" onClick={() => setAuditModal(true)}>Save</button>&nbsp;
                    <Link className="btn btn-primary btn-outline" to="/rolemanagement">Return to List</Link>
                </div>
            </div>

            {auditModal ? <AuditModal header="Align Roles To Role" isSubmitting={submitting} onClose={() => setAuditModal(false)} onSubmit={handleSave} /> : null}
        </DocumentTitle>
    );
}
